export const languages = {
  enUS: 'en-US',
  esES: 'es-ES',
  frBE: 'fr-BE',
  frFR: 'fr-FR',
};
